const get = (name) => new URLSearchParams(window.location.search).get(name);

const getNumber = (name) => parseInt(get(name), 10);

const getCategory = () =>
  document.URL.split("/")[4] === "category" && document.URL.split("/")[5];

export const query = {
  get,
  getNumber,
  getCategory
};
